import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/containers/components/htmlContent/HTMLContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/common/AirlinesSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/common/HotelsSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/JsonLd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/searchTab/components/tabs/components/TabDrawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/searchTab/components/tabs/flight/FlightTab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/searchTab/components/tabs/hotel/HotelTab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/searchTab/components/tabs/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/searchTab/components/tabs/tour/TourTab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/layouts/landing/components/CheapestFlightsToday.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/layouts/landing/components/LandingHotelPromos.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/layouts/landing/components/PageContentFAQ.tsx");
